module.exports = __webpack_public_path__ + "static/img/bannerworden.af51b70.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/bannerworden.png
// module id = QS7L
// module chunks = 45